import FeatureHighlighted from './FeatureHighlighted'

export default FeatureHighlighted
